'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

const ComboboxOptionDescription = forwardRef(({ children, className, ...rest }, ref) => {
    return (jsx("span", { className: cl('ds-combobox__option__description', className), ref: ref, ...rest, children: children }));
});
ComboboxOptionDescription.displayName = 'ComboboxOptionDescription';

export { ComboboxOptionDescription as default };
